import React, { useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { clearObject, getObjectById } from "../globalState/object/actions";
import { useUserRole } from "../App";

export const WithObjectComponentHOC = (Component) => {

  const SetObjectComponent = (props) => {
    const { match, getObjectById, objectId, clearObject, stepByStep } = props
    const objectIdByNavParams = match.params.objectId
    const userRole = useUserRole()

    const history = useHistory()

    const withRedirect = useCallback(async () => {
      clearObject()
      const res = await getObjectById(objectIdByNavParams)

      if (res === "redirect") {
        history.push("/lk")
      }
    }, [clearObject, getObjectById, history, objectIdByNavParams])

    useEffect(() => {
      if ((!objectId && objectIdByNavParams) || (objectId !== objectIdByNavParams)) {
        withRedirect();
      }
    }, [clearObject, getObjectById, history, objectId, objectIdByNavParams, withRedirect])


    const memoizedRedirectToStepByStep = useMemo(() => {
      return (objectId && stepByStep && stepByStep !== "N" && match.path !== "/lk/:objectId?/fastCreateObject" && userRole !== "MODERATOR")
    }, [match.path, objectId, stepByStep, userRole]);


    useEffect(() => {
      if (memoizedRedirectToStepByStep) {
        history.replace(`/lk/${objectId}/fastCreateObject`)
      }
    }, [history, memoizedRedirectToStepByStep, objectId])


    return <Component {...props} />
  }


  const mapStateToProps = (state) => ({
    objectId: state.object.id,
    stepByStep: state.object.stepByStep
  })


  return compose(connect(mapStateToProps, { clearObject, getObjectById }))(SetObjectComponent)
}
